const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 1024,
    lg: 1366,
    xl: 1920,
  },
};

export { breakpoints };
